import {PropsWithChildren} from 'react';
import clsx from 'clsx';
import {twMerge} from 'tailwind-merge';

import Arrow from '@/assets/images/icon-arrow-next.svg?react';
import Button from '@/components/button';
import {TrackingProps} from '@/components/tracked-atoms/types';
import {BUTTON_VARIANT, BUTTON_THEME} from '@/constants/button';

type Props = PropsWithChildren<{
  className?: string;
  trackingKey: TrackingProps['trackingKey'];
  onClick: () => void;
}>;

export const ListItem = ({onClick, children, className, trackingKey, ...props}: Props) => {
  return (
    <Button
      {...props}
      className={twMerge(
        'w-full justify-start border-2 border-transparent',
        'bg-purple-100 text-violet hover:bg-purple-200',
        '!rounded-2 px-4 py-3 text-left',
        className,
      )}
      label={<>{children}</>}
      trackingKey={trackingKey}
      icon={<Arrow className={clsx('ml-auto size-3 fill-violet')} />}
      iconPosition="right"
      onClick={onClick}
      variant={BUTTON_VARIANT.FULL_WIDTH}
      theme={BUTTON_THEME.STYLELESS}
    />
  );
};
